<template>
  <v-row justify="end">
    <v-dialog
      v-model="dialog"
      :persistent="loading"
      max-width="480"
      content-class="create-dialog text-center">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          elevation="0"
          :ripple="false"
          :loading="loading"
          :disabled="$_.isEmpty(barcodeFormat) || $_.isEmpty(itemIds)"
          v-bind="attrs"
          rounded
          v-on="on"
          @click="createBarcode()">
          สร้างบาร์โค้ด
        </v-btn>
      </template>
      <v-card>
        <div class="body-card">
          <div
            v-if="loading"
            class="wrap-progress-circular d-flex justify-center align-center my-0 mx-auto">
            <v-progress-circular
              indeterminate
              color="primary" />
          </div>
          <v-icon
            v-else
            color="success"
            size="80">
            mdi-check-circle-outline
          </v-icon>
          <div>
            <h3 class="mt-10 body-1 font-weight-bold">
              {{
                loading
                  ? "กำลังสร้างบาร์โค้ด"
                  : "สร้างบาร์โค้ด"
              }}
            </h3>
            <p class="mt-2 mb-0 grey--text body-2 font-weight-medium">
              {{ loading ? ' ' : 'ระบบได้ทำการสร้างบาร์โค้ดให้สินค้าเรียบร้อยแล้ว' }}
            </p>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { GENERATE_PRODUCT_BARCODE } from '@/resources/graphql'

export default {
  props: {
    itemIds: {
      type: Array,
      default: () => [],
      require: true
    },
    barcodeFormat: {
      type: [String],
      default: '',
      require: true
    }
  },
  data () {
    return {
      dialog: false,
      loading: false
    }
  },
  methods: {
    async createBarcode () {
      const input = {
        ids: this.itemIds,
        barcodeFormat: this.barcodeFormat
      }

      this.loading = true
      await this.mutationGenerateProductBarcode(input)
      this.loading = false
    },
    async mutationGenerateProductBarcode (input) {
      try {
        const {
          data: {
            generateProductBarcode: { errors }
          }
        } = await this.$apollo.mutate({
          mutation: GENERATE_PRODUCT_BARCODE,
          variables: { input }
        })

        if (this.$_.isEmpty(errors)) {
          this.$emit('onSuccess')
        } else {
          throw new Error(errors)
        }
      } catch (error) {
        this.$notify.error(this.$t('app.tryAgain'))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.create-dialog {
  min-width: 480px;
  .body-card {
    padding: 54px 0;
    background-color: white;
  }
  .wrap-progress-circular {
    width: 80px;
    height: 80px;
  }
}
</style>
